<template>
    <div class="loading-indicator-wrapper">
        <div class="loader"></div>
    </div>
</template>

<script>
    export default {
        name: "Spinner"
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/color_palette";

    .loading-indicator-wrapper {
        margin: 0 auto;
        position: relative;
        text-align: center;
        z-index: 998;
        padding-bottom: 10px;
        height: 35px;

        &.loader-hidden {
            display: none;
        }
        .loader {
            background: yellow($key: '100');
            color: yellow($key: '100');
            text-indent: -9999em;
            margin: 10px auto;
            position: relative;
            font-size: 11px;

            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);

            -webkit-animation: load1 1s -0.16s infinite ease-in-out;
            animation: load1 1s -0.16s infinite ease-in-out;
            width: 5px;
            height: 10px;

            &:after,
            &:before {
                -webkit-animation: load1 1s infinite ease-in-out;
                animation: load1 1s infinite ease-in-out;
                width: 5px;
                height: 10px;
                position: absolute;
                top: 0;
                content: '';
            }
            &:before {
                background: blue($key: '100');
                color: blue($key: '100');
                left: -1em;
                -webkit-animation-delay: -0.32s;
                animation-delay: -0.32s;
            }
            &:after {
                background: orange($key: '100');
                color: orange($key: '100');
                left: 1em;
            }
        }
    }

    @-webkit-keyframes load1 {
        0%,
        80%,
        100% {
            box-shadow: 0 0;
            height: 10px;
        }
        40% {
            box-shadow: 0 -1em;
            height: 15px;
        }
    }
    @keyframes load1 {
        0%,
        80%,
        100% {
            box-shadow: 0 0;
            height: 10px;
        }
        40% {
            box-shadow: 0 -1em;
            height: 15px;
        }
    }
</style>